import formatCurrency from "../../../helpers/currencyHelper"
import React from "react"

const Hotspot = (props) => {
  let spot = props.spot
  const spotContentStyle = {
    backgroundColor: spot.BgColor,
    color: spot.TextColor,
  }

  const spotStyle = {
    top: spot.VerticalPlacement + "%",
    left: spot.HorizontalPlacement + "%",
  }

  const dotStyle = {
    backgroundColor: spot.BgColor,
  }

  const innerDotStyle = {
    backgroundColor: spot.DotColor,
  }

  let verticalDirection = spot.VerticalPlacement > 50 ? "v-open-up" : "v-open-down"
  let horizontalDirection = spot.HorizontalPlacement === 50 ? "h-open-center" : spot.HorizontalPlacement > 50 ? "h-open-left" : "h-open-right"

  if (spot.Product) {
    let productInfo = spot.Product
    return (
      <div className="hotspot" style={spotStyle}>
        <a href={productInfo.PageUrl}>
          <div style={spotContentStyle} className={"hotspot-content hidden " + verticalDirection + " " + horizontalDirection}>
            <span>
              <h4>{productInfo.Brand}</h4>
            </span>
            <p>{productInfo.Name}</p>
            {getPriceDom(productInfo)}
          </div>
        </a>
        {dot(props.onClick, dotStyle, innerDotStyle)}
      </div>
    )
  } else {
    return (
      <div className="hotspot" style={spotStyle}>
        <div style={spotContentStyle} className={"hotspot-content hidden " + verticalDirection + " " + horizontalDirection}>
          <h4>{spot.Heading}</h4>
          <div dangerouslySetInnerHTML={{ __html: spot.Text }}></div>
        </div>
        {dot(props.onClick, dotStyle, innerDotStyle)}
      </div>
    )
  }
}

const dot = (onClick, dotStyle, innerDotStyle) => {
  return (
    <div style={dotStyle} onClick={(e) => onClick(e)} className={"hotspot-dot"}>
      <div style={innerDotStyle} className={"hotspot-inner-dot"}></div>
    </div>
  )
}

const getPriceDom = (product) => {
  const discountedPrice = product.DiscountedPrice
  if (discountedPrice < product.Price) {
    return (
      <React.Fragment>
        <div id="onSalePriceOriginal" className="product-price-original">
          {formatCurrency(product.Price)} kr
        </div>
        <div id="onSalePrice" className="product-price discount">
          {formatCurrency(discountedPrice)} kr
        </div>
      </React.Fragment>
    )
  } else {
    return <div className="product-price">{formatCurrency(product.Price)} kr</div>
  }
}

export default Hotspot
